// // TODO: after updating to ts 4.1, this can be refactored to utilize template literal types
// // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-4-1.html#template-literal-types

import { EffectConfig } from '@ngrx/effects/src/models';
import { TypedAction } from '@ngrx/store/src/models';
import { Observable } from 'rxjs';
import { mergeMap, switchMap } from 'rxjs/operators';

import { ActionsFromConfig, EntityActionCreator } from '../types';

export enum RecognizedAction {
  fetch = 'fetch',
  update = 'update',
  fetchOne = 'fetchOne',
  fetchCollection = 'fetchCollection',
  fetchPaginatedCollection = 'fetchPaginatedCollection',
  createOneOptimistic = 'createOneOptimistic',
  createOnePessimistic = 'createOnePessimistic',
  updateOneOptimistic = 'updateOneOptimistic',
  updateOnePessimistic = 'updateOnePessimistic',
  removeOneOptimistic = 'removeOneOptimistic',
  removeOnePessimistic = 'removeOnePessimistic',
}

export type DataType<T> = Omit<T, 'scope' | 'correlationId' | 'updateId'>;
type SuccessAction<T extends string> = `${T}Success`;
type FailedAction<T extends string> = `${T}Failed`;

export type EffectActionPayload<
  EntityActions extends ActionsFromConfig<any>,
  Creator extends EntityActionCreator<any, any>,
> = Creator extends { type: `${RecognizedAction}` }
  ?
      | DataType<ReturnType<EntityActions[SuccessAction<Creator['type']>]>['payload']>
      | DataType<ReturnType<EntityActions[FailedAction<Creator['type']>]>['payload']>
  : never;

export type KnownEffectPayloadGuard<P> = P extends EffectActionPayload<any, any> ? P : never;

type DispatchFlagGuard<Config extends EffectConfig> = Config extends { dispatch: false }
  ? false
  : true;

export type EffectHandler<
  EA extends ActionsFromConfig<any>,
  C extends EntityActionCreator<any, any>,
  Config extends EffectConfig,
  P = EffectActionPayload<EA, C>,
> = KnownEffectPayloadGuard<P> extends never
  ? (
      action: ReturnType<C>,
    ) => DispatchFlagGuard<Config> extends true ? Observable<TypedAction<any>> : any
  : (action: ReturnType<C>) => Observable<P>;

export interface CustomEffectsConfig extends EffectConfig {
  customMapOperator?: typeof switchMap | typeof mergeMap;
}
